import React, { Component, Fragment } from 'react';
import { get, postWithHeaders, postWithHeadersResponse } from "../../../server/actions";
import { currency_symbol } from '../../../server/constants'
import ReactTable from 'react-table';
import ReactTooltip from 'react-tooltip'
import '../../../../src/assets/css/react-table.css'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { BeatLoader } from 'react-spinners';
import '../../../../node_modules/react-datetime/css/react-datetime.css';
import NotificationSystem from 'react-notification-system';
import PropTypes from "prop-types";
import {
    _addNotification, _addNotificationError,
    formatDate, allowNumericWithdecimal, getWeekStartEndDates, getMonthStartEndDates, getSessionStartEndDates,
    getTodayStartEndDates,
    showFile, convertTwoDecimalPoint, getLastMonthStartEndDates
} from "../../../server/util";
import moment from 'moment';
//import { debugger } from 'fusioncharts';
var _ = require('lodash');
class AccountHistoryDistrict extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mealSchoolId:0,
            schoolId:0,
            loading: false,
            transactionData: [],
            ID: 0,
            studentFName: '',
            studentLName: '',
            hdataFilter: { ID: 0, tdate: 'D', sdate: new Date(), edate: new Date() }
        }
        this.getAccountHistoryData = this.getAccountHistoryData.bind(this)
    }
    componentWillMount = () => {
        let  id  =  this.props.data;
        let schoolId  = this.props.mealSchoolId;
        this.setState({ ID: id, mealSchoolId:schoolId  }, () => {
            this.getAccountHistoryData(id);
        });
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    getAccountHistoryData = (id, isPdf = false) => {
        let _self = this;
        let userInfo = {};
        if ((sessionStorage.getItem('ROLE')) === "ROLE_ADMIN") {
            userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        }
        let date = {}
        if (this.state.hdataFilter.tdate === 'W') {
            date = getWeekStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'M') {
            date = getMonthStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'LM') {
            date = getLastMonthStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'Y') {
            date = getSessionStartEndDates(sessionStorage.getItem('schoolYearValue'))
        } else if (this.state.hdataFilter.tdate === 'C') {
            date = { startDate: this.state.hdataFilter.sdate, endDate: this.state.hdataFilter.edate }
        } else {
            date = getTodayStartEndDates(new Date())
        }
        this.setState({ loading: true });
        get('/reports/transactionsHistory?studentRecId=' + id + '&startDate=' + moment(date.startDate).utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(date.endDate).utc().format("YYYY-MM-DDTHH:mm:ss") + '&fileExport=' + isPdf + '&access_token=').then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
                //throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            if (isPdf) {
                let filename = (this.state.studentFName + ' ' + this.state.studentLName) + '_AccountHistory.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                console.log(JSON.stringify(data.studentAccountDetails.accountTransactionHistories));
                this.setState({
                    transactionData: (data.studentAccountDetails||{}).accountTransactionHistories||[], loading: false,
                    studentFName: data.studentAccountDetails.studentFName, studentLName: data.studentAccountDetails.studentLName
                })
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                //console.log('Get Excel File response', error)
                this.setState({ loading: false })
            }
        );
    }
    render() {
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (
            <section className="full-width clearfix">
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container ">
                    <div className="sectionTitle">
                        <div className="row">
                            <h2 className="col-md-6" id="deleteLabel">{'Account History:  ' + this.state.studentFName + ' ' + this.state.studentLName}
                                {/* <span>Account History</span> */}
                               
                            </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-info" style={{ padding: '5px', marginBottom: '5px' }} >
                                <div onChange={(event) => {
                                    let hdataFilter = this.state.hdataFilter;
                                    hdataFilter.tdate = event.target.value;
                                    this.setState({ hdataFilter: hdataFilter })
                                    if (event.target.value !== "C") {
                                        this.getAccountHistoryData(this.state.ID, false);
                                    }
                                }}>
                                    <label class="rbcontainer">Today
                                                    <input type="radio" name="hdrange" value="D" defaultChecked={this.state.hdataFilter.tdate === 'D'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">This Week
                                                    <input type="radio" name="hdrange" value="W" defaultChecked={this.state.hdataFilter.tdate === 'W'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">This Month
                                                    <input type="radio" name="hdrange" value="M" defaultChecked={this.state.hdataFilter.tdate === 'M'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">Last Month
                                                    <input type="radio" name="hdrange" value="LM" defaultChecked={this.state.hdataFilter.tdate === 'LM'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">This Year
                                                    <input type="radio" name="hdrange" value="Y" defaultChecked={this.state.hdataFilter.tdate === 'Y'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">Custom Dates
                                                    <input type="radio" name="hdrange" value="C" defaultChecked={this.state.hdataFilter.tdate === 'C'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    {
                                        this.state.hdataFilter.tdate === 'C' ?
                                            <DateRangePicker onApply={(event, picker) => {
                                                let hdataFilter = this.state.hdataFilter;
                                                hdataFilter.sdate = picker.startDate._d;
                                                hdataFilter.edate = picker.endDate._d;
                                                this.setState({ hdataFilter: hdataFilter })
                                                console.log('sdate --:', event, picker)
                                                this.getAccountHistoryData(this.state.ID, false);
                                            }}>
                                                <button className="btn btn-xs bg-color-1" style={{ margin: '0px', minWidth: '20px' }}><i className="fa fa-calendar"></i></button>
                                            </DateRangePicker> : null
                                    }
                                    <a title="Click to Download PDF"
                                        onClick={() => { this.getAccountHistoryData(this.state.ID, true) }//this.quickReports('Pdf','currentDay')
                                        } target='_blank'
                                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF pull-right"><i /></a>
                                </div></div></div></div>
                    <ReactTable columns={[
                        {
                            Header: "Date",
                            accessor: "transactionDateTime",
                            width: 200,
                            style: { textAlign: 'center' },
                        },
                        {
                            Header: "Transaction",
                            id: 'transaction',
                            style: { textAlign: 'center' },
                            accessor: row => {
                                return (<span>{
                                    row.transactionType === 'Deposit' || row.transactionType=== "InstantPayment" || row.transactionType=== "Donation" ?
                                    (row.isPosDeposit ? 'POS ':'')+row.transactionType + ' - ' + (row.paymentType === 'CreditCard' ? 'CC' : row.paymentType) :
                                        (row.purchaseItemType === 'TransferDR' ? 'Transfer Withdrawal' :
                                            row.purchaseItemType === '' ? row.paymentType : row.purchaseItemType)}
                                </span>)
                            }
                        },
                        {
                            Header: `Account (${currency_symbol(this.state.mealSchoolId)})`,
                            id: 'amount',
                            style: { textAlign: 'center' },
                            accessor: row => {
                                return (
                                    <div>
                                        {
                                            currency_symbol(this.state.mealSchoolId) + ' '
                                            + (row.transactionType === 'Deposit' || ((row.transactionType === 'ImportBalance' || row.transactionType === 'Adjustment' || row.transactionType === 'Refund') && row.paymentType) ? '+' : '-') + convertTwoDecimalPoint(row.transactionAmount)
                                        }
                                    </div>
                                );
                            }
                        },
                        {
                            Header: `Balance (${currency_symbol(this.state.mealSchoolId)})`,
                            id: "finalBalance",
                            style: { textAlign: 'center' },
                            accessor: row => {
                                return (
                                    <div>
                                        {currency_symbol(this.state.mealSchoolId) + ' ' + convertTwoDecimalPoint(row.finalBalance)}
                                    </div>
                                );
                            }
                        },
                        {
                            Header: "Note",
                            id: "note",
                            style: { textAlign: 'center' },
                            minWidth: 75,
                            filterable: false,
                            Cell: row => {
                                return (
                                    <Fragment>
                                        <a data-tip data-for={'ah-' + row.index}>{row.original.note}</a>
                                        <ReactTooltip id={'ah-' + row.index} aria-haspopup='true' type="dark" effect="float">
                                            <div>
                                                {row.original.note}
                                            </div>
                                        </ReactTooltip>
                                    </Fragment>
                                )
                            }
                        }
                    ]} data={this.state.transactionData} defaultPageSize={10} {...checkboxProps} />
                </div>
            </section>
        )
    }
}
AccountHistoryDistrict.contextTypes = {
    router: PropTypes.object.isRequired
}
export default AccountHistoryDistrict;


// WEBPACK FOOTER //
// ./src/components/District/manageStudents/accountHistoryDistrict.jsx